import Home from "./components/home/home";
import About from "./components/About/About"
import Contact from "./components/Contact/Contact"
import Projects from "./components/Projects/Projects"
import Services from "./components/Services/Services"

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Planning from "./components/Services/Planning";
import Interior from "./components/Services/Interior";
import Consulting from "./components/Services/Consulting";
import Supervising from "./components/Services/Supervising";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Help from "./components/Help/help";


function App() {
  return (
    <div className="bg-background w-full">
        <Router>
      <div className="w-full bg-background overflow-x-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          
          <Route path="/about-us" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          
          <Route path="/services" element={<Services />} />
          <Route path="/services/planning" element={<Planning />} />
          <Route path="/services/interior" element={<Interior />} />
          <Route path="/services/consulting" element={<Consulting /> }/>
          <Route path="/services/supervising" element={<Supervising /> }/>
          
          <Route path="/privacyPolicy" element={<PrivacyPolicy /> }/>
          <Route path="/help" element={<Help /> }/>

          <Route path="*" element={<Home />} />
        </Routes>
      </div>
    </Router>
    </div>
  );
}

export default App;
